<!-- MAP VIEW -->

<div #mapContainer id="map" ></div>
